// extracted by mini-css-extract-plugin
export var fullWidthButton = "_do-0";